import { QueryFilters } from '../types';

// Produces a scalar representation of the filter object; we use it to detect changes which trigger useEffect
// below, as filter object is constructed on each draw from scratch.
export function filterFingerprint(filters: QueryFilters): string {
  return [
    Number(filters.removeZeroTaxableReceipts),
    ...filters.reportingStatus,
    ...filters.penalties,
    ...filters.interest,
    ...filters.discrepancy,
  ].join(',');
}
